/**
 * @file HOC for checking auth status on discover mode.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import qs from 'query-string';

const WithAuthentication = WrappedComponent =>
  class extends Component {
    static propTypes = {
      authenticated: PropTypes.bool.isRequired,
      match: PropTypes.shape({
        params: PropTypes.shape({
          albumFolderId: PropTypes.string.isRequired,
        }),
      }),
      staticContext: PropTypes.shape({
        query: PropTypes.object,
      }),
    };

    render() {
      const { authenticated, match, staticContext } = this.props;

      return !authenticated ? (
        <Redirect
          to={{
            pathname: `/discover/album-folder/${match.params.albumFolderId}/start`,
            search: `?${qs.stringify(staticContext?.query ?? '')}`,
          }}
        />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export { WithAuthentication };

export default (WrappedComponent, authType) => {
  return compose(connect(mapStateToProps), WithAuthentication)(
    WrappedComponent,
    authType,
  );
};
